import { render, staticRenderFns } from "./beanDetail.vue?vue&type=template&id=3b394e43&scoped=true"
import script from "./beanDetail.vue?vue&type=script&lang=js"
export * from "./beanDetail.vue?vue&type=script&lang=js"
import style0 from "./beanDetail.vue?vue&type=style&index=0&id=3b394e43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b394e43",
  null
  
)

export default component.exports